export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setAccessDriver(state, accessDriver) {
    state.accessDriver = accessDriver;
  },
  setAccessDrivers(state, accessDrivers) {
    state.accessDrivers = accessDrivers;
  },
  setWarehouses(state, warehouses) {
    state.warehouses = warehouses;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-driver/store/mutations.js